import { datadogRum } from "@datadog/browser-rum";
import type { Accounting } from "../api/engage/engage.types";
import type { ShellUser } from "../api/types";
import type { OnesaasConsent } from "../portals/messagemedia/onesaas-consent-cookie";
import { createClientEvent } from "./createClientEvent";
import {
  createRudderStackClientEvent,
  type TrackEventPayloadWithOptionalPurposes,
} from "./createRudderstackEvent";
import { DataCollectors, trackEventPayloadZod } from "./eventTypes";
import { hasUserConsentedToEvent } from "./handleEventPurpose";
import { trackRudderStackEvent } from "./rudderstack";

export const handleTrackEventPayload =
  (
    dataCollectors: DataCollectors[],
    user: ShellUser,
    accounting: Partial<Accounting>,
    isConsentRequired: boolean,
    onesaaasConsent: Partial<OnesaasConsent>
  ) =>
  (eventPayload: TrackEventPayloadWithOptionalPurposes) => {
    const parsed = trackEventPayloadZod.safeParse(eventPayload);

    if (!parsed.success) {
      return console.error(parsed.error);
    }

    const parsedEventPayload = parsed.data;
    const debugConsole = JSON.parse(
      sessionStorage.getItem("_debug") || "false"
    ) as boolean;

    if (
      !hasUserConsentedToEvent(
        parsedEventPayload,
        isConsentRequired,
        onesaaasConsent
      )
    ) {
      return console.warn(
        `Couldn't figure consent for event ${eventPayload.name}`
      );
    }

    if (dataCollectors.includes(DataCollectors.Datadog)) {
      const clientEvent = createClientEvent(eventPayload, user, accounting);

      if (debugConsole) console.log("clientEvent", clientEvent);
      if (dataCollectors.includes(DataCollectors.Datadog)) {
        datadogRum.addAction(clientEvent.eventInfo.eventType, clientEvent);
      }
    }
    if (dataCollectors.includes(DataCollectors.RudderStack)) {
      const rudderStackClientevent = createRudderStackClientEvent(
        eventPayload,
        user
      );
      if (debugConsole) console.log("rudderStackEvent", rudderStackClientevent);

      trackRudderStackEvent(
        rudderStackClientevent.event.type,
        rudderStackClientevent
      );
    }
  };
